module.exports = __webpack_public_path__ + "img/fullScreen.33299a0d.svg";